import { Icon } from "../../../../components/icon";
import Loading from "../../../../assets/icons/loading.svg"

export const AbrirContaLoading = () => {
    return(
        <div className='conta-content'>
            <div  style={{display:"flex", flexDirection:"column", alignItems:"center", gap:20}}>
                <Icon icon={Loading} size={88}/>
                <span style={{fontSize:"1.667rem", fontWeight:700}}>Processando</span>
                <span style={{fontSize:"1.112rem", fontWeight:200}}>Espere alguns minutos</span>
            </div>
         </div>
    )
}